import { Button, Spinner } from "reactstrap";

const LoadingButton = ({ children, disabled, ...props }) => (
	<Button {...props} disabled={disabled}>
		{disabled ? <Spinner size="sm" /> : children}
	</Button>
);

export default LoadingButton;
